/**
 * Extract a SAFE same-origin relative path from a `?next=` query string.
 *
 * Used by the login flow to return the user to the page they originally
 * requested (e.g. the interview-report link from the completion email) after
 * they authenticate. Guards against open-redirects: the value must be a
 * site-relative path starting with a single "/" — never a scheme
 * ("https://evil") or a protocol-relative URL ("//evil"). Returns null when the
 * param is absent or unsafe, so callers fall back to their default destination.
 */
export function getSafeNextPath(search) {
    try {
        const raw = new URLSearchParams(search || '').get('next');
        if (!raw)
            return null;
        const decoded = decodeURIComponent(raw);
        if (!decoded.startsWith('/') || decoded.startsWith('//'))
            return null;
        return decoded;
    }
    catch (_a) {
        return null;
    }
}
export default getSafeNextPath;
